module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAAXNSR0IArs4c6QAAAQ1JREFUOBGdkT0OwjAMhV1TfhYm9m4IJAYOgJg4AsfgEr0QR4ABDgAMiJmeAYny04S8gKsUmlYiUhXHee+rYxN91qk77Elct7tahngXRpPb9bI4tqJRnRkaaOGB1gI4DNqBiR9KzasguIMGWngAMPF7HTrRjJ5qqolUk3k5uidHucPumilsbMbpeY18DsDBB/GZfwBlEOSkbPfPyGMVKninipV8REwhb8dpshKN7LaJcpAdQubghGbh0yYuM0NfCsCbM6UHAiQTI5efneDnCcWG8dZqK6ZTAHybpWzfdADPAT6zVOuDWECduQpim5iR7huSd1QCsE8y44QWHsmTjmPee7qci5wAWnic1P/hC5DCsAfGc1TdAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/pages/CarEditorPage/components/carActiveMenu/img/delete.png
// module id = 1658
// module chunks = 0